module.exports = __webpack_public_path__ + "static/WEDDING E&M-564-ad4ea9452ceaf271d5dfef6788652708.jpg";